import {provideHttpClient, withInterceptorsFromDi,} from "@angular/common/http";
import {NgModule} from "@angular/core";
import {HttpLink} from "apollo-angular/http";

import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {environment} from "../environments/environment";
import {AppRoutingModule} from "./app-routing.module";
import {GraphQLModule} from "./checkout/graphql.module";
import {CoreModule} from "./core.module";
import {AdminModule} from "./modules/admin/admin.module";
import {AoCartModule} from "./modules/ao-cart/ao-cart.module";
import {AppComponent} from "./modules/app.component";
import {CartOverviewModule} from "./modules/cart/cart-overview/cart-overview.module";
import {CatalogModule} from "./modules/cart/catalog/catalog.module";
import {RegisterAngularLocales} from "./modules/locale/register-angular-locales";
import {MarketingPageModule} from "./modules/marketing-pages/marketing-page.module";
import {OrderHistoryModule} from "./modules/orders/order-history.module";
import {ProductModule} from "./modules/product/product.module";
import {SkinAnalyzerResultsModule} from "./modules/skin-analyzer/results/skin-analyzer-results.module";
import {ShareableModule} from "./modules/social/shareable/shareable.module";
import {SurveyResultsModule} from "./modules/survey/survey-results.module";

import {provideCmsAppRouteFactory, provideCmsContentstackClient,} from "@usana/ux/cms";

RegisterAngularLocales.registerLocales();

//This module should contain feature modules and bootstrap app component.
//Should also import AppRoutingModule which will contain all feature modules that are lazy loaded.
@NgModule({
    bootstrap: [AppComponent],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        CoreModule,
        GraphQLModule,
        AdminModule,
        AoCartModule,
        CatalogModule,
        CartOverviewModule,
        MarketingPageModule,
        OrderHistoryModule,
        ProductModule,
        ShareableModule,
        SkinAnalyzerResultsModule,
        SurveyResultsModule,
        AppRoutingModule,
    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi()),
        HttpLink,
        provideCmsContentstackClient({
            apiKey: environment.contentStack.apiKey,
            deliveryToken: environment.contentStack.deliveryToken,
            environment: environment.contentStack.environment,
            region: environment.contentStack.region as
                | "US"
                | "EU"
                | "AZURE_NA"
                | "AZURE_EU"
                | "GCP_NA",
            branch: environment.contentStack.branch,
            defaultLocale: "en-us", // optional
            host: environment.contentStack.contentDelivery, // optional (CDN host)
            endpoint: environment.contentStack.endpoint,
        }),
        provideCmsAppRouteFactory(() => {
            return {
                template_marketing_pages: {
                    cmsPrefix: "/mkt",
                    appUrlBuilder: (url, locale) => {
                        return `/ux/dotcom/${locale}${url}`;
                    },
                },
            };
        }),
    ],
})
export class AppModule {}
